import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Register controllers manually (importmap doesn't support dynamic context loading)
import FlashController from "./flash_controller"
import FlatpickrController from "./flatpickr_controller"
import ApprovalToggleController from "./approval_toggle_controller"
import SquadronSelectController from "./squadron_select_controller"
import SquadronManagementController from "./squadron_management_controller"
import RoleManagementController from "./role_management_controller"
import StatusFormController from "./status_form_controller"

application.register("flash", FlashController)
application.register("flatpickr", FlatpickrController)
application.register("approval-toggle", ApprovalToggleController)
application.register("squadron-select", SquadronSelectController)
application.register("squadron-management", SquadronManagementController)
application.register("role-management", RoleManagementController)
application.register("status-form", StatusFormController)
